import { render, staticRenderFns } from "./ReportOldSiteMenu.vue?vue&type=template&id=a7e87dd2&scoped=true&"
import script from "./ReportOldSiteMenu.vue?vue&type=script&lang=js&"
export * from "./ReportOldSiteMenu.vue?vue&type=script&lang=js&"
import style0 from "./ReportOldSiteMenu.vue?vue&type=style&index=0&id=a7e87dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e87dd2",
  null
  
)

export default component.exports